import { render, staticRenderFns } from "./EntitiesMultiselect.vue?vue&type=template&id=2afa8ebe"
import script from "./EntitiesMultiselect.vue?vue&type=script&lang=js"
export * from "./EntitiesMultiselect.vue?vue&type=script&lang=js"
import style0 from "./EntitiesMultiselect.vue?vue&type=style&index=0&id=2afa8ebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports